import clsx from 'clsx'
import AudioPlayer from 'app/components/AudioPlayer'
import styles from './styles.module.scss'

function Voice({ renderRepliedMsgPreview, url, className, type }) {
  return (
    <div data-type={type} className={clsx(styles.voice_message, className)}>
      {renderRepliedMsgPreview}
      <AudioPlayer source={url} />
    </div>
  )
}

export default Voice
